module.exports = __webpack_public_path__ + "img/envelope-regular.1a9020c3.svg";